import React from 'react';

export const PlaceholderCatalogCard: React.FC<{
  title: string;
  caption?: string;
  children?: React.ReactNode;
}> = ({ title, caption = 'Coming later', children }) => (
  <div className="relative flex flex-col rounded-xl border border-border bg-card p-3 opacity-80">
    <span className="absolute top-2 right-2 rounded-full bg-muted px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
      Soon
    </span>
    <div className="aspect-[4/3] overflow-hidden rounded-md border border-border bg-muted">
      {children}
    </div>
    <p className="mt-2 text-sm font-semibold">{title}</p>
    <p className="text-xs text-muted-foreground">{caption}</p>
  </div>
);
